import React from 'react'
import StockLedgerReport from '../Components/Reports/StockLedgerReport'

function StockLedgerReportPage() {
  return (
    <>
      <StockLedgerReport/>
    </>
  )
}

export default StockLedgerReportPage
